import React from 'react';
import LayersSrc from './layers.svg';
import CloseSrc from './close.svg';
import * as S from './styled';

export const BurgerBtn = ({ messageCount, isOpen = false, ...restProps }) => (
  <S.Burger {...restProps}>
    {messageCount && <S.Label>{messageCount}</S.Label>}
    {isOpen && <img src={CloseSrc} alt="" />}
    {!isOpen && <img src={LayersSrc} alt="" />}
  </S.Burger>
);
